import { curry, toPairs, pipe, map, over, lensIndex, fromPairs } from 'ramda';
var renameKeysWith = curry(function (fn, obj) {
    return pipe(toPairs, map(over(lensIndex(0), fn)), fromPairs)(obj);
});
export default renameKeysWith;
